function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useRef, useLayoutEffect, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { omit, isEmpty } from "lodash-es";
import Modal from "react-modal";
import Button from "../../components/button/Button";
import { useForceUpdate } from "../../helpers/hooks";
import LoadingAnimation from "../../components/loadinganimation/LoadingAnimation";
const ConfirmModal = props => {
  const confirmModalButton = useRef();
  const [forceUpdateState, forceUpdate] = useForceUpdate();
  const {
    HeaderComponent
  } = props;
  useLayoutEffect(() => {
    if (props.isOpen) {
      if (confirmModalButton.current) {
        confirmModalButton.current.focus();
      } else {
        forceUpdate();
      }
    }
  }, [props.isOpen, forceUpdateState]);
  useEffect(() => {
    const onKeyUp = event => {
      if (event.key === "Escape") {
        props.onCancel();
      }
    };
    window.addEventListener("keyup", onKeyUp, false);
    return () => window.removeEventListener("keyup", onKeyUp, false);
  }, [props.onCancel]);
  return /*#__PURE__*/React.createElement(Modal, _extends({
    overlayClassName: "modal-overlay",
    className: classNames("confirm-modal-content", {
      "with-message": !isEmpty(props.message)
    })
  }, omit(props, "style", "header", "HeaderComponent", "confirmText", "cancelText", "isLoading", "isSubmitting"), {
    appElement: props.appElement || document.querySelector("div") || document.querySelector("body"),
    style: {
      content: props.style
    },
    aria: {
      busy: props.isLoading || props.isSubmitting
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "confirm-modal"
  }, /*#__PURE__*/React.createElement(HeaderComponent, {
    className: "confirm-header"
  }, props.header), props.message && /*#__PURE__*/React.createElement("p", {
    className: "confirm-content"
  }, props.message), (props.isLoading || props.isSubmitting) && /*#__PURE__*/React.createElement("div", {
    className: "loader-overlay"
  }, /*#__PURE__*/React.createElement(LoadingAnimation, null))), /*#__PURE__*/React.createElement("div", {
    className: "confirm-footer"
  }, props.isAlert ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "md",
    ref: confirmModalButton,
    id: "confirmModalButton",
    onClick: props.onConfirm
  }, props.alertText) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "destructive",
    onClick: props.onCancel,
    style: {
      marginRight: 10
    },
    disabled: props.isLoading || props.isSubmitting
  }, props.cancelText), /*#__PURE__*/React.createElement(Button, {
    variant: "confirm",
    ref: confirmModalButton,
    id: "confirmModalButton",
    onClick: props.onConfirm,
    disabled: props.isLoading,
    isLoading: props.isSubmitting
  }, props.confirmText))));
};
ConfirmModal.displayName = "ConfirmModal";
ConfirmModal.defaultProps = {
  appElement: undefined,
  style: {},
  header: "Are you sure?",
  HeaderComponent: "h3",
  confirmText: "Yes",
  cancelText: "No",
  message: "",
  isAlert: false,
  alertText: "OK",
  isLoading: false,
  isSubmitting: false
};
ConfirmModal.propTypes = {
  appElement: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  style: PropTypes.object,
  header: PropTypes.node,
  HeaderComponent: PropTypes.any,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  confirmText: PropTypes.node,
  cancelText: PropTypes.node,
  message: PropTypes.node,
  isAlert: PropTypes.bool,
  alertText: PropTypes.node,
  isLoading: PropTypes.bool,
  isSubmitting: PropTypes.bool
};
export default ConfirmModal;
//# sourceMappingURL=ConfirmModal.js.map